import { render, staticRenderFns } from "./SeparatorProperty.vue?vue&type=template&id=6ed8e272&"
import script from "./SeparatorProperty.vue?vue&type=script&lang=js&"
export * from "./SeparatorProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports